import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import SwitchButtons from '../switch';
import TopupData from '../form';
import { getLabelsByLanguage } from '../../../../utilites/util';
import BankCardsImages from '../bank-cards/BankCardsImages';
import Topup, { TopupType } from '../../../../constants/TopupTypes';
import { getItemFromSessionStorage } from '../../../../utilites/localStorage';
import { useDispatch } from 'react-redux';
import { topupAnalyticsStepAction } from '../../../../app/store/analytics/actions';

interface Props {
  setLoading: Dispatch<SetStateAction<boolean>>;
  setErrors: Dispatch<SetStateAction<string[]>>;
  handleStepChange: (stepNumber: number) => void;
}

const TopupInputStep: React.FC<Props> = ({ setLoading, setErrors, handleStepChange }) => {
  const dispatch = useDispatch();
  const { topupText10, topupText11, topupText12 } = getLabelsByLanguage();
  const topupData = getItemFromSessionStorage('topupData', '{}');
  const activeTopupType = topupData?.topupType ?? Topup.STANDARD;

  const [topupType, setTopupType] = useState<TopupType>(activeTopupType);

  const handleChangeTopupType = (desiredTopupType: TopupType) => {
    sessionStorage.removeItem('topupData');
    setTopupType(desiredTopupType);
  };

  useEffect(() => {
    dispatch(topupAnalyticsStepAction({ step: 1 }));
  }, []);

  return (
    <>
      <SwitchButtons activeSwitch={topupType} handleSwitch={handleChangeTopupType} />

      <div className="ytope-form-container">
        <TopupData
          activeTopupType={topupType}
          setLoading={setLoading}
          setErrors={setErrors}
          handleStepChange={handleStepChange}
        />

        <section>
          <section className="yettel-light-font mb-5 text-left">
            <p className="mb-2">{topupText10}</p>
            <p className={`mb-2 ${topupType !== Topup.INTERNET ? 'd-none' : ''}`}>
              <strong>{topupText11}</strong> {topupText12}
            </p>
          </section>

          <BankCardsImages />
        </section>
      </div>
    </>
  );
};

export default TopupInputStep;
